import {formatDate, filterByDateOptions} from '../../../epsrc/assets/utils/helper'
import Vue from 'vue';
export const epBaseDetails = {
    namespaced: true,
    state: {
        app_roles: ['User'], // default set to user
        selectedFilterOptions: {
          selectedOption: null,
          fromDate: null,
          toDate: null
        },
        selectedDetailsFilterOptions: {
          selectedOption: null,
          fromDate: null,
          toDate: null,
        },
        domainsInfo: [],
        fetchedDomainsInfo: false,
        companyName: null,
        inProgressDomains: [],
        pollingDomainsProgress: null,
        domainAction: 'delete',
        updateDomainsPage: 0,
        breachName: null,
        emailAddress: null,
        showAllCompaniesDashboard: null,
        allCompaniesCount: 0,
        currentUserAppRole: null,
        companyAppRoles: null
    },
    getters: {
      getShowAllCompaniesDashboard(state) {
        return state.showAllCompaniesDashboard;
      },
      getSelectedFilterOptions(state) {
        let filterOptions = {...state.selectedFilterOptions};
        let params = {};
        let option = filterOptions.selectedOption;
        let fromDate = formatDate(filterOptions.fromDate);
        let toDate = formatDate(filterOptions.toDate);
        if (option && option !== 'custom') {
            params['date_range'] = option;
        }
        if (fromDate && toDate) {
            params['from'] = fromDate;
            params['to'] = toDate;
        }
        return params;
      },
      getSelectedDetailsFilterOptions(state) {
        let filterOptions = {...state.selectedDetailsFilterOptions};
        let params = {};
        let option = filterOptions.selectedOption;
        let fromDate = formatDate(filterOptions.fromDate);
        let toDate = formatDate(filterOptions.toDate);
        let domain = filterOptions.domain
        if (option && option !== 'custom') {
            params['date_range'] = option;
        }
        if (fromDate && toDate) {
            params['from'] = fromDate;
            params['to'] = toDate;
        }
        if(domain) {
          params['domain'] = domain
        }
        return params;
      },
      getSelectedOptionDisplayName(state) {
        let filterOptions = state.selectedFilterOptions;
        if (filterOptions.selectedOption !== null) {
          return filterByDateOptions[filterOptions.selectedOption] || null;
        }
        return null;
      },
      getSelectedFilterOptionKey(state) {
        return state.selectedFilterOptions;
      },
      getSelectedDetailsOptionDisplayName(state) {
        let filterOptions = state.selectedDetailsFilterOptions;
        if (filterOptions.selectedOption !== null) {
          return filterByDateOptions[filterOptions.selectedOption] || null;
        }
        return null;
      },
      getSelectedDetailsFilterOptionKey(state) {
        return state.selectedDetailsFilterOptions;
      },
      getDomainsInfo(state) {
        return state.domainsInfo;
      },
      getDomainsLength(state) {
        return state.domainsInfo.length;
      },
      getCompanyName(state) {
        return state.companyName
      },
      getInprogressDomains(state) {
        return state.inProgressDomains
      },
      getPollingDomainsEvent(state) {
        return state.pollingDomainsProgress;
      },
      getBreachName(state) {
        return state.breachName
      },
      getEmailAddress(state) {
        return state.emailAddress
      },
      getAllCompaniesCount(state) {
        return state.allCompaniesCount
      },
      getCurrentUserRole(state) {
        return state.companyAppRoles
      }
    },
    actions: {
      setShowCompanyDashboard({state, commit}, val) {
        commit('saveShowAllCompaniesDashboard', val)
      },
      updateAppRoles({state}, appRoles){
        state.app_roles = appRoles;
      },
      updateSelectedFilterOptions({state, commit}, val) {
        commit('saveSelectedFilterOption', val)
      },
      updateSelectedDetailsFilterOptions({state, commit}, val) {
        commit('saveSelectedDetailsFilterOption', val)
      },
      updateDomainsInfo({state, commit}, val) {
        commit('setDomainsInfo', val);
      },
      addNewDomain({state, commit}, val) {
        commit('setNewDomain', val)
      },
      deleteSelectedDomain({state, commit}, val) {
        commit('deleteDomain', val)
      },
      updateFetchedDomainsInfo({state, commit}, val) {
        commit('setFetchedDomainsInfo', val);
      },
      updateCompanyName({state, commit}, val) {
        commit('saveCompanyName', val);
      },
      updateDomainsInProgress({state, commit}, val) {
        commit('saveDomainsProgress', val)
      },
      addDomainsToInProgress({state, commit}, val) {
        commit('addDomainsProgress', val)
      },
      updatePollingDomainsEvent({state, commit}, val) {
        commit('savePollingEvent', val)
      },
      fetchNewDomainsProgress({state, commit}) {
        let self = this;
        Vue.http.get('/apps/ep/get_status/', {
            params: {
                domains: state.inProgressDomains
            }
        }).then((res) => {
          let update = false;
          if(res.data.length < state.inProgressDomains.length) {
            update = true
          }
          commit('saveDomainsProgress', res.data)
          if(res.data.length == 0) {
            commit('savePollingEvent', null)
          }
          if (update) {
            commit('saveUpdateDomainsPage');
          }
        }, (error) => {
            console.log("error while fetching domains status");
            console.log(error);
            commit('saveDomainsProgress', []);
        })
      },
      updateBreachName( {state, commit}, val) {
        commit('saveBreachName', val)
      },
      updateEmailAddress( {state, commit}, val ) {
        commit('saveEmailAddress', val)
      },
      updateAllCompaniesCount( {state, commit}, val) {
        commit('saveAllCompaniesCount', val)
      },
      updateCompanyAppRoles({state, commit}, val) {
        commit('saveCompanyAppRoles', val)
      }
    },
    mutations: {
      saveSelectedFilterOption(state, val) {
        state.selectedFilterOptions = {...val}
      },
      saveSelectedDetailsFilterOption(state, val) {
        state.selectedDetailsFilterOptions = {...val}
      },
      setDomainsInfo(state, val) {
        state.domainsInfo = val;
      },
      setNewDomain(state, val) {
        state.domainsInfo.push(val);
        state.domainAction = 'add'
      },
      deleteDomain(state, val) {
        let domains = [...state.domainsInfo];
        domains.splice(domains.indexOf(val), 1)
        state.domainsInfo = [...domains]
        state.domainAction = 'delete'
      },
      setFetchedDomainsInfo(state, val) {
        state.fetchedDomainsInfo = val;
      },
      saveCompanyName(state, val) {
        state.companyName = val;
      },
      saveDomainsProgress(state, val) {
        state.inProgressDomains = val;
      },
      addDomainsProgress(state, val) {
        state.inProgressDomains.push(val);
      },
      savePollingEvent(state, val) {
        if(val === null) {
          clearInterval(state.pollingDomainsProgress)
        }
        state.pollingDomainsProgress = val;
      },
      saveUpdateDomainsPage(state) {
        state.updateDomainsPage = state.updateDomainsPage + 1;
      },
      saveBreachName(state, val) {
        state.breachName = val;
      },
      saveEmailAddress(state, val) {
        state.emailAddress = val;
      },
      saveShowAllCompaniesDashboard(state, val) {
        state.showAllCompaniesDashboard = val;
      },
      saveAllCompaniesCount(state, val) {
        state.allCompaniesCount = val
      },
      saveCompanyAppRoles(state, val) {
        state.companyAppRoles = val
      }
    },
  };
  
